import { Component, OnInit } from '@angular/core';
import { FirebaseService } from '../services/firebase.service';
import { CustomerDataService } from '../services/customer-data.service';

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.scss']
})
export class CustomerComponent implements OnInit {

  public companiesData: any = [];
  public features: any = {
    solar: { ea: 'Energy Availability', pc: 'Powercurve', analytics: 'Analytics', vis: 'Visualization', observations: 'observations', cmms: 'CMMS' },
    wind: { ea: 'Energy Availability', pc: 'Powercurve', analytics: 'Analytics', vis: 'Visualization', observations: 'observations', cmms: 'CMMS' }
  };
  constructor(private firebaseService: FirebaseService, private cdService: CustomerDataService) { }

  ngOnInit(): void {
    //this.getData()
    /* this.firebaseService.getCompanies().subscribe((data: any) => {
      this.companiesData = data
      // console.log(data)
      this.cdService.setCompanies(data);
    }); */

    this.cdService.message.subscribe(data => {
      this.companiesData = data
      // console.log(this.companiesData)
    })
    // this.data.getUserStatus().subscribe(res => res)

    // this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  /* async getData() {
    const data = await this.cdService.getCompanyData();
    console.log(data, 'data in comp')
  } */


}
